export const tlc = ( string: string | undefined ): string | undefined => {
    if ( string ) {
        return string.toLowerCase().trim().replaceAll(' ', '');
    }
    return undefined;
}

export const formatDate = ( timeStamp: number | undefined, includeYear:boolean = true ): string => {

    if ( timeStamp ) {
        return new Date( timeStamp ).toLocaleDateString( 'fi-FI', { timeZone: 'Europe/Helsinki', day: 'numeric', month: 'numeric', year: includeYear ? 'numeric' : undefined} );
    }
    return '';
}

export const formatTime = ( timeStamp: number | undefined ): string => {
    if ( timeStamp ) {
        return new Date( timeStamp ).toLocaleTimeString( 'fi-FI', { timeZone: 'Europe/Helsinki', hour: "2-digit", minute: "2-digit"} ).replaceAll('.', ':');
    }
    return '';
}

export const sanitizeFilename = ( string: string | undefined ): string => {
    if ( string ) {
        const invalidCharsRegex = /[<>:"/\\|?*\x00-\x1F]/g;
        const sanitizedFilename = string.replace(invalidCharsRegex, '');
        return sanitizedFilename;
    }
    return '';
}
